import { storeProgramServiceClient } from '../../utils/HttpClient'

import { StoreProgramPublicDetails, StoreProgramResponse } from '.'

const STORE_PROGRAM_ENRICHMENT_OPTIONS = [
  'ENRICH_STORE_PROGRAM_CONFIG',
  'ENRICH_CLIENT_DETAILS',
  'ENRICH_STORE_PROGRAM_DETAILS',
]

/**
 * Fetches public store-program list for the B2B landing/login pages.
 * @example input: ("quince", "my-program") -> output: [{ id: "1", slug: "my-program", ... }]
 */
export const fetchStoreProgramPublicList = async (clientCode: string, program?: string) => {
  try {
    const { data } = await storeProgramServiceClient.get<StoreProgramPublicDetails[]>(`/stores/programs/public`, {
      params: {
        programType: 'STOREFRONT',
        clientCode,
        slug: program,
      },
    })

    return data
  } catch (e: unknown) {
    console.error('[fetchStoreProgramPublicList] FAILED:', e)
    return []
  }
}

/**
 * Fetches a single store-program with config and client details enrichment.
 * @example input: 42 -> output: { id: 42, storeProgramConfig: { fundingType: "COMPANY_FUNDED" } }
 */
export const fetchStoreProgramById = async (storeProgramId: number): Promise<StoreProgramResponse> => {
  try {
    const { data } = await storeProgramServiceClient.get<StoreProgramResponse>(`/stores/programs/${storeProgramId}`, {
      params: {
        enrichmentOptions: STORE_PROGRAM_ENRICHMENT_OPTIONS.join(','),
      },
    })
    return data
  } catch (e: unknown) {
    console.error('[fetchStoreProgramById] FAILED:', e)
    throw e
  }
}

/**
 * Checks if a store program is a Quince-owned self-service program.
 * Intended for server-side use (e.g. getServerSideProps).
 * On the client, use `isB2BSelfService` from StorefrontModeContext instead
 * (see storefront-mode-context.provider.tsx).
 */
export const isSelfServeProgram = (storeProgram?: StoreProgramResponse): boolean =>
  storeProgram?.storeProgramConfig?.isQuinceOwnedSelfService ?? false
